import React, { useContext, useRef } from "react";
import Link from "next/link";
import cls from "./header.module.scss";
import { BrandLogo, BrandLogoDark } from "components/icons";
import { ThemeContext } from "contexts/theme/theme.context";
import dynamic from "next/dynamic";
import SearchContainer from "containers/searchContainer/searchContainer";
import { useAuth } from "contexts/auth/auth.context";
import useModal from "hooks/useModal";
import AddressContainer from "containers/addressContainer/addressContainer";
import CartButton from "components/cartButton/cartButton";
import { useTranslation } from "react-i18next";
import NotificationStats from "components/notificationStats/notificationStats";
import { useRouter } from "next/router";

const AppDrawer = dynamic(() => import("components/appDrawer/appDrawer"));
const ProfileDropdown = dynamic(
  () => import("components/profileDropdown/profileDropdown"),
);

export default function Header() {
  const { t } = useTranslation();
  const { pathname } = useRouter();
  const { isDarkMode } = useContext(ThemeContext);
  const { isAuthenticated, user, openAuthModal } = useAuth();
  const [appDrawer, handleOpenAppDrawer, handleCloseAppDrawer] = useModal();

  const searchContainerRef = useRef(null);

  return (
    <div className={`${cls.container} ${pathname !== "/" && cls.bordered}`}>
      <div className="container">
        <header className={cls.header}>
          <div className={cls.navItem}>
            {!isAuthenticated && (
              <button
                type="button"
                className={cls.menuBtn}
                onClick={handleOpenAppDrawer}
                aria-label="menu"
              >
                <svg
                  className={cls.menuIcon}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    fill="currentColor"
                    d="M1.66699 14.1667C1.66699 14.625 2.04199 15 2.50033 15H17.5003C17.9587 15 18.3337 14.625 18.3337 14.1667C18.3337 13.7083 17.9587 13.3333 17.5003 13.3333H2.50033C2.04199 13.3333 1.66699 13.7083 1.66699 14.1667ZM1.66699 10C1.66699 10.4583 2.04199 10.8333 2.50033 10.8333H17.5003C17.9587 10.8333 18.3337 10.4583 18.3337 10C18.3337 9.54167 17.9587 9.16667 17.5003 9.16667H2.50033C2.04199 9.16667 1.66699 9.54167 1.66699 10ZM1.66699 5.83333C1.66699 6.29167 2.04199 6.66667 2.50033 6.66667H17.5003C17.9587 6.66667 18.3337 6.29167 18.3337 5.83333C18.3337 5.375 17.9587 5 17.5003 5H2.50033C2.04199 5 1.66699 5.375 1.66699 5.83333Z"
                  />
                </svg>
              </button>
            )}
            <Link href="/" className={cls.brandLogo}>
              {isDarkMode ? <BrandLogoDark /> : <BrandLogo />}
            </Link>
          </div>
          <div
            className={`${cls.navItem} ${cls.searchBar}`}
            ref={searchContainerRef}
          >
            <div className={cls.search}>
              <SearchContainer searchContainerRef={searchContainerRef} />
            </div>
          </div>
          <div className={cls.navItem}>
            <AddressContainer />
          </div>
          <NotificationStats />
          <div className={cls.navItem}>
            <CartButton />
          </div>
          {isAuthenticated ? (
            <ProfileDropdown data={user} />
          ) : (
            <button type="button" onClick={openAuthModal} className={cls.login}>
              {t("login")}
            </button>
          )}
        </header>
      </div>
      <AppDrawer open={appDrawer} handleClose={handleCloseAppDrawer} />
    </div>
  );
}
